import React from 'react';
import ReactDOM from 'react-dom';
import '../styles/design_system/main.scss';
import reportWebVitals from './reportWebVitals';
// inject i18  config to the app
import { I18nextProvider } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logger from '@functions/logger';
import { store } from '@redux/store';
import { Provider } from 'react-redux';
import i18n from './assets/i18n/config';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { environment } from './environments/environment';

const persistor = persistStore(store);

toast.configure();

// switch theme based on subdomain
const mainHtml = document.getElementById("switch-theme") as HTMLElement;
const hostname = window.location.hostname;
const hostnameSplited = hostname.split('.');

console.log('hostname: ' + hostname);

console.log('hostnameSplited: ' + hostnameSplited);

if (hostnameSplited.length === 3 && hostnameSplited[0]) {
    sessionStorage.setItem('subdomain',hostnameSplited[0])
    switch (hostnameSplited[0]) {
        case 'gyc':
        case 'drgyc':
            mainHtml.className = "DrProxGnC";
            break;
        case 'drmpc':
        case 'mpc':
            mainHtml.className = "DrProxMPC";
            break;
        case 'drcentromater':
        case 'centromater':
            mainHtml.className = "DrProxCentroMater";
            break;
        case 'drhubio':
        case 'hubio':
            mainHtml.className = "DrProxHubio";
            break;
        case 'drschiller':
        case 'schiller':
            mainHtml.className = "DrProxSchillerAmericas";
            break;
        case 'drexacolor':
            mainHtml.className = "DrProxExacolor";
            break;
        default:
            break;
    }
}

ReactDOM.render(
    // strict mode help us to prevent potential issues at run time(just affect development builds)
    <React.StrictMode>
        {/* Inject react redux store provider */}
        <GoogleOAuthProvider clientId={environment.googleClientId}>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <I18nextProvider i18n={i18n}>
                        <App />
                        <ToastContainer />
                    </I18nextProvider>
                </PersistGate>
            </Provider>
        </GoogleOAuthProvider>
    </React.StrictMode>,

    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(logger.log);
